{
  "valid": "Válido",
  "expired": "Caducado",
  "month": "{n} mes | {n} mes",
  "days": "{n} día restante | {n} días restantes",
  "keystore": {
    "generateSelfSignedCertificate": "Generar un certificado autofirmado",
    "generateCSR": "Generar un CSR",
    "csrRequiresUploadCertificate": "Esta solicitud de firma de certificado necesita añadir un certificado",
    "list": {
      "action": {
        "delete": {
          "description": "El certificado {alias} se va a eliminar."
        }
      }
    },
    "updateCertificate": "Actualizar el certificado",
    "csr": "CSR",
    "certificate": "Certificado",
    "error": {
      "csr": {
        "loading": "Error al cargar la CSR."
      }
    },
    "automaticRenewal": {
      "label": "Renovación automática del certificado",
      "csr": {
        "info": "La renovación automática se ejecutará diariamente si hay una configuración PKI asociada con este certificado. También puede activar la renovación inmediatamente pulsando el botón.",
        "buttonLabel": "Generar certificado"
      }
    },
    "filters": {
      "searchByAlias": "Buscar por alias"
    }
  },
  "download": "Descargar certificado",
  "delete": "Eliminar certificado",
  "noCertificate": "No hay ningún certificado disponible",
  "tag": "Etiqueta",
  "tags": {
    "label": "Etiquetas",
    "empty": "No se encontró ninguna etiqueta"
  },
  "alias": "Alias",
  "expiration": {
    "timestamp": {
      "label": "Fecha de caducidad",
      "labelColon": "Fecha de caducidad:"
    }
  },
  "list": {
    "column": {
      "timestamp": {
        "format": "DD/MM/AAAA a HH:mm"
      }
    },
    "action": {
      "delete": {
        "description": "El certificado {alias} se va a eliminar."
      }
    }
  },
  "form": {
    "serialNumber": "Número de serie",
    "organizationUnit": "Unidad de organización",
    "organization": "Organización",
    "locality": "Localidad",
    "region": "Región",
    "country": "País",
    "tags": {
      "placeholder": "Seleccionar",
      "remove": {
        "tooltip": "Haga clic para retirar la etiqueta"
      }
    },
    "associatedPkiConfiguration": "Configuración PKI asociada",
    "cn": "CN",
    "email": "E-mail"
  },
  "validation": {
    "alias": {
      "required": "El alias es obligatorio.",
      "invalid": "El alias no debe contener letras latinas en minúsculas, números con guiones, guiones bajos ni espacios."
    },
    "cn": "El CN es obligatorio",
    "email": "El correo electrónico es obligatorio.",
    "certificate": {
      "invalid": "El certificado no parece ser válido.",
      "extension": "El certificado no contiene una extensión correcta.",
      "fileEmpty": "El archivo no debe estar vacío",
      "fileSize": "El tamaño del archivo no debe superar 750 MB."
    },
    "associatedPkiConfiguration": "Advertencia: La renovación automática del certificado no se realizará si el certificado/CSR no está asociado con una configuración PKI."
  },
  "error": {
    "certificate": {
      "loading": "Error al cargar el certificado."
    }
  },
  "truststore": {
    "uploadCertificate": "Añadir el certificado",
    "editCertificate": "Modificar el certificado"
  },
  "filters": {
    "searchByAlias": "Buscar por alias"
  },
  "cancelAction": {
    "confirm": {
      "message": "¿Seguro que quiere anular esta operación? Todos los datos se perderán."
    }
  },
  "chain": {
    "label": "Cadena de certificados",
    "level": "nivel {level}"
  },
  "downloadCSR": "Descargar CSR",
  "subject": {
    "label": "Asunto"
  },
  "subjectAlternativeName": {
    "label": "Nombre alternativo del sujeto",
    "add": "Añadir SAN",
    "empty": "No se ha definido ningún SAN.",
    "delete": "Eliminar el SAN",
    "noValue": "Falta el valor",
    "unknownError": "Se ha producido un error desconocido durante la verificación.",
    "type": "Tipo",
    "value": "Valor",
    "2": {
      "label": "DNS",
      "labelColon": "DNS:",
      "invalidFormat": "El valor debe ser una dirección DNS válida."
    },
    "7": {
      "label": "IP",
      "labelColon": "IP",
      "invalidFormat": "El valor debe ser una dirección IP válida."
    }
  },
  "extendedKeyUsage": {
    "label": "Uso ampliado de claves",
    "empty": "No se ha definido ningún EKU.",
    "1": "Autenticación de servidor",
    "2": "Autenticación de cliente"
  },
  "tab": {
    "keystore": "Almacén de claves",
    "truststore": "Almacén de confianza"
  },
  "trustChain": {
    "label": "Cadena de certificados"
  },
  "start": {
    "timestamp": {
      "labelColon": "Fecha de inicio de validez:"
    }
  }
}
